import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeCross extends Shape {
    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width / 2 - 2 * horizontalPadding;
        const allowedHeight = height / 2 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width / 4, y);
        canv.ctx.lineTo(x + (width * 3) / 4, y);
        canv.ctx.lineTo(x + (width * 3) / 4, y + height / 4);
        canv.ctx.lineTo(x + width, y + height / 4);
        canv.ctx.lineTo(x + width, y + (height * 3) / 4);
        canv.ctx.lineTo(x + (width * 3) / 4, y + (height * 3) / 4);
        canv.ctx.lineTo(x + (width * 3) / 4, y + height);
        canv.ctx.lineTo(x + width / 4, y + height);
        canv.ctx.lineTo(x + width / 4, y + (height * 3) / 4);
        canv.ctx.lineTo(x, y + (height * 3) / 4);
        canv.ctx.lineTo(x, y + height / 4);
        canv.ctx.lineTo(x + width / 4, y + height / 4);
        canv.ctx.lineTo(x + width / 4, y);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M18.25 6.25V6.75H18.75H23.75C23.9489 6.75 24.1397 6.82904 24.2803 6.96964C24.421 7.11034 24.5 7.30114 24.5 7.5V17.5C24.5 17.6989 24.4209 17.8897 24.2803 18.0303C24.1397 18.1709 23.9489 18.25 23.75 18.25H18.75H18.25V18.75V23.75C18.25 23.9489 18.1709 24.1397 18.0303 24.2803C17.8897 24.4209 17.6989 24.5 17.5 24.5H7.5C7.30114 24.5 7.11034 24.421 6.96963 24.2803C6.82904 24.1397 6.75 23.9489 6.75 23.75V18.75V18.25H6.25H1.25C1.05114 18.25 0.860338 18.171 0.719628 18.0303C0.579039 17.8897 0.5 17.6989 0.5 17.5V7.5C0.5 7.3011 0.579011 7.11034 0.719657 6.96968C0.860321 6.82902 1.05109 6.75 1.25 6.75H6.25H6.75V6.25V1.25C6.75 1.05109 6.82902 0.860321 6.96968 0.719657C7.11034 0.579011 7.3011 0.5 7.5 0.5H17.5C17.6989 0.5 17.8897 0.579039 18.0303 0.719638C18.171 0.860338 18.25 1.05114 18.25 1.25V6.25Z"/>
            </svg>
        `;
    }
}
